// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1P1O8","productName":"Table_productName__3Hq7k"};